import { LEGAL_EXTENSIONS } from '@flows/configs/legal/constants'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

const legal_tenant = (params: StepConfigParams) =>
  ({
    stepContent: [
      {
        type: 'title',
        text: { type: 'translatableText', translationKey: 'sharedFlows_legal:steps.tenant.title' },
      },
      {
        type: 'yesNo',
        shouldTrackValues: true,
        name: `product_keys.${LEGAL_EXTENSIONS.tenantProductKey}`,
      },
      {
        type: 'infoBox',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_legal:steps.tenant.info.text',
        },
        title: {
          type: 'translatableText',
          translationKey: 'sharedFlows_legal:steps.tenant.info.title',
        },
      },
    ],
    subFlow: params.subFlow,
    nextStep: 'legal_criminal',
  }) as const satisfies AnyStepConfiguration

export default legal_tenant
